// extracted by css-extract-rspack-plugin
export default {"timeline":"timeline-M2lKVd","line":"line-IVP9O_","lineWithSpinner":"lineWithSpinner-WirPnm"};